/* tslint:disable */
/* eslint-disable */
/**
 * DUPR Backend APIs (Internal)
 * Internal RESTful APIs to access DUPR ratings, users and provide matches.
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../base';
// @ts-ignore
import type { AuthResponse } from '../../../commons/generated/model';
// @ts-ignore
import type { AuthResponseWrapper } from '../../../commons/generated/model';
// @ts-ignore
import type { ConsentGrantRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { DeviceRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { EmailExistRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { ErrorWrapper } from '../../../commons/generated/model';
// @ts-ignore
import type { LoginRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { PlayerSignUpRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { ReadOnlyAuthResponseWrapper } from '../../../commons/generated/model';
// @ts-ignore
import type { ResetPasswordWithTokenRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { SingleWrapperAuthResponse } from '../../../commons/generated/model';
// @ts-ignore
import type { SingleWrapperBoolean } from '../../../commons/generated/model';
// @ts-ignore
import type { SingleWrapperUserResponse } from '../../../commons/generated/model';
// @ts-ignore
import type { TwoFactorResendRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { TwoFactorVerifyRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { UserActionRequiredResponse } from '../../../commons/generated/model';
// @ts-ignore
import type { VerifyTokenRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { Wrapper } from '../../../commons/generated/model';
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {DeviceRequest} deviceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceRegistration: async (version: string, deviceRequest: DeviceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('deviceRegistration', 'version', version)
            // verify required parameter 'deviceRequest' is not null or undefined
            assertParamExists('deviceRegistration', 'deviceRequest', deviceRequest)
            const localVarPath = `/auth/{version}/device`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        emailAlreadyExists: async (version: string, email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('emailAlreadyExists', 'version', version)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('emailAlreadyExists', 'email', email)
            const localVarPath = `/auth/email/{version}/exists`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {EmailExistRequest} emailExistRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        emailExists: async (version: string, emailExistRequest: EmailExistRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('emailExists', 'version', version)
            // verify required parameter 'emailExistRequest' is not null or undefined
            assertParamExists('emailExists', 'emailExistRequest', emailExistRequest)
            const localVarPath = `/auth/email/{version}/exists`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailExistRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Grant PII consent and receive read-only auth tokens
         * @param {string} version 
         * @param {ConsentGrantRequest} consentGrantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantConsentAndLogin: async (version: string, consentGrantRequest: ConsentGrantRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('grantConsentAndLogin', 'version', version)
            // verify required parameter 'consentGrantRequest' is not null or undefined
            assertParamExists('grantConsentAndLogin', 'consentGrantRequest', consentGrantRequest)
            const localVarPath = `/auth/{version}/consent/grant`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consentGrantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateResetPassword: async (version: string, email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('initiateResetPassword', 'version', version)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('initiateResetPassword', 'email', email)
            const localVarPath = `/auth/password/{version}/initiate`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (version: string, loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('login', 'version', version)
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('login', 'loginRequest', loginRequest)
            const localVarPath = `/auth/{version}/login`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticate user and initiate consent flow for read-only token
         * @param {string} version 
         * @param {string} xAuthorization 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginReadOnlyToken: async (version: string, xAuthorization: string, loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('loginReadOnlyToken', 'version', version)
            // verify required parameter 'xAuthorization' is not null or undefined
            assertParamExists('loginReadOnlyToken', 'xAuthorization', xAuthorization)
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('loginReadOnlyToken', 'loginRequest', loginRequest)
            const localVarPath = `/auth/{version}/login-read-only-token`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAuthorization != null) {
                localVarHeaderParameter['x-authorization'] = String(xAuthorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Convert session to read-only token, initiating consent flow if enabled
         * @param {string} version 
         * @param {string} xAuthorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginReadOnlyTokenWithFullAccessToken: async (version: string, xAuthorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('loginReadOnlyTokenWithFullAccessToken', 'version', version)
            // verify required parameter 'xAuthorization' is not null or undefined
            assertParamExists('loginReadOnlyTokenWithFullAccessToken', 'xAuthorization', xAuthorization)
            const localVarPath = `/auth/{version}/login-read-only-token-with-session`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xAuthorization != null) {
                localVarHeaderParameter['x-authorization'] = String(xAuthorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        panelLogin: async (version: string, loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('panelLogin', 'version', version)
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('panelLogin', 'loginRequest', loginRequest)
            const localVarPath = `/auth/panel/{version}/login`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Takes a refresh token in the `x-refresh-token` header. v2.0+ returns a full `AuthResponse`; v1.0 returns only the newly issued access token as a raw string wrapped in the standard envelope (see `RefreshedTokenWrapper`). The refresh token itself is the credential — no bearer `Authorization` header is required.
         * @summary Refresh an access token (supports both regular and read-only tokens)
         * @param {string} version 
         * @param {string} xRefreshToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAccessToken: async (version: string, xRefreshToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('refreshAccessToken', 'version', version)
            // verify required parameter 'xRefreshToken' is not null or undefined
            assertParamExists('refreshAccessToken', 'xRefreshToken', xRefreshToken)
            const localVarPath = `/auth/{version}/refresh`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xRefreshToken != null) {
                localVarHeaderParameter['x-refresh-token'] = String(xRefreshToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {PlayerSignUpRequest} playerSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (version: string, playerSignUpRequest: PlayerSignUpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('register', 'version', version)
            // verify required parameter 'playerSignUpRequest' is not null or undefined
            assertParamExists('register', 'playerSignUpRequest', playerSignUpRequest)
            const localVarPath = `/auth/{version}/signup`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(playerSignUpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend 2FA verification code via SMS
         * @param {string} version 
         * @param {TwoFactorResendRequest} twoFactorResendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendTwoFactorCode: async (version: string, twoFactorResendRequest: TwoFactorResendRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('resendTwoFactorCode', 'version', version)
            // verify required parameter 'twoFactorResendRequest' is not null or undefined
            assertParamExists('resendTwoFactorCode', 'twoFactorResendRequest', twoFactorResendRequest)
            const localVarPath = `/auth/{version}/2fa/resend`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(twoFactorResendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {string} code 
         * @param {string} xPassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword1: async (version: string, email: string, code: string, xPassword: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('resetPassword1', 'version', version)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('resetPassword1', 'email', email)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('resetPassword1', 'code', code)
            // verify required parameter 'xPassword' is not null or undefined
            assertParamExists('resetPassword1', 'xPassword', xPassword)
            const localVarPath = `/auth/password/{version}/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            if (xPassword != null) {
                localVarHeaderParameter['x-password'] = String(xPassword);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redeems the signed, single-use reset token (from the emailed link) and sets a new password supplied in the x-password header.
         * @summary Complete a password reset from an emailed reset link
         * @param {string} version 
         * @param {string} xPassword 
         * @param {ResetPasswordWithTokenRequest} resetPasswordWithTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordWithToken: async (version: string, xPassword: string, resetPasswordWithTokenRequest: ResetPasswordWithTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('resetPasswordWithToken', 'version', version)
            // verify required parameter 'xPassword' is not null or undefined
            assertParamExists('resetPasswordWithToken', 'xPassword', xPassword)
            // verify required parameter 'resetPasswordWithTokenRequest' is not null or undefined
            assertParamExists('resetPasswordWithToken', 'resetPasswordWithTokenRequest', resetPasswordWithTokenRequest)
            const localVarPath = `/auth/password/{version}/reset/token`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xPassword != null) {
                localVarHeaderParameter['x-password'] = String(xPassword);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordWithTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerificationEmail1: async (version: string, email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('sendVerificationEmail1', 'version', version)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('sendVerificationEmail1', 'email', email)
            const localVarPath = `/auth/email/{version}/resend`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAmbassadorCode: async (version: string, code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('validateAmbassadorCode', 'version', version)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('validateAmbassadorCode', 'code', code)
            const localVarPath = `/auth/{version}/validate`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailAddress1: async (version: string, email: string, code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('verifyEmailAddress1', 'version', version)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('verifyEmailAddress1', 'email', email)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('verifyEmailAddress1', 'code', code)
            const localVarPath = `/auth/email/{version}/verify`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify 2FA challenge code and complete login
         * @param {string} version 
         * @param {TwoFactorVerifyRequest} twoFactorVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTwoFactor: async (version: string, twoFactorVerifyRequest: TwoFactorVerifyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('verifyTwoFactor', 'version', version)
            // verify required parameter 'twoFactorVerifyRequest' is not null or undefined
            assertParamExists('verifyTwoFactor', 'twoFactorVerifyRequest', twoFactorVerifyRequest)
            const localVarPath = `/auth/{version}/2fa/verify`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(twoFactorVerifyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {VerifyTokenRequest} verifyTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUserEmail: async (version: string, verifyTokenRequest: VerifyTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('verifyUserEmail', 'version', version)
            // verify required parameter 'verifyTokenRequest' is not null or undefined
            assertParamExists('verifyUserEmail', 'verifyTokenRequest', verifyTokenRequest)
            const localVarPath = `/auth/email/{version}/verify`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} version 
         * @param {DeviceRequest} deviceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceRegistration(version: string, deviceRequest: DeviceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Wrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceRegistration(version, deviceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.deviceRegistration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async emailAlreadyExists(version: string, email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleWrapperBoolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailAlreadyExists(version, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.emailAlreadyExists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {EmailExistRequest} emailExistRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async emailExists(version: string, emailExistRequest: EmailExistRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleWrapperBoolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailExists(version, emailExistRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.emailExists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Grant PII consent and receive read-only auth tokens
         * @param {string} version 
         * @param {ConsentGrantRequest} consentGrantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantConsentAndLogin(version: string, consentGrantRequest: ConsentGrantRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadOnlyAuthResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantConsentAndLogin(version, consentGrantRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.grantConsentAndLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateResetPassword(version: string, email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Wrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateResetPassword(version, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.initiateResetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(version: string, loginRequest: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleWrapperAuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(version, loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Authenticate user and initiate consent flow for read-only token
         * @param {string} version 
         * @param {string} xAuthorization 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginReadOnlyToken(version: string, xAuthorization: string, loginRequest: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadOnlyAuthResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginReadOnlyToken(version, xAuthorization, loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.loginReadOnlyToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Convert session to read-only token, initiating consent flow if enabled
         * @param {string} version 
         * @param {string} xAuthorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginReadOnlyTokenWithFullAccessToken(version: string, xAuthorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadOnlyAuthResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginReadOnlyTokenWithFullAccessToken(version, xAuthorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.loginReadOnlyTokenWithFullAccessToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async panelLogin(version: string, loginRequest: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleWrapperAuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.panelLogin(version, loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.panelLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Takes a refresh token in the `x-refresh-token` header. v2.0+ returns a full `AuthResponse`; v1.0 returns only the newly issued access token as a raw string wrapped in the standard envelope (see `RefreshedTokenWrapper`). The refresh token itself is the credential — no bearer `Authorization` header is required.
         * @summary Refresh an access token (supports both regular and read-only tokens)
         * @param {string} version 
         * @param {string} xRefreshToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshAccessToken(version: string, xRefreshToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponseWrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshAccessToken(version, xRefreshToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.refreshAccessToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {PlayerSignUpRequest} playerSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(version: string, playerSignUpRequest: PlayerSignUpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleWrapperAuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(version, playerSignUpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend 2FA verification code via SMS
         * @param {string} version 
         * @param {TwoFactorResendRequest} twoFactorResendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendTwoFactorCode(version: string, twoFactorResendRequest: TwoFactorResendRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendTwoFactorCode(version, twoFactorResendRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.resendTwoFactorCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {string} code 
         * @param {string} xPassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword1(version: string, email: string, code: string, xPassword: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Wrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword1(version, email, code, xPassword, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.resetPassword1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redeems the signed, single-use reset token (from the emailed link) and sets a new password supplied in the x-password header.
         * @summary Complete a password reset from an emailed reset link
         * @param {string} version 
         * @param {string} xPassword 
         * @param {ResetPasswordWithTokenRequest} resetPasswordWithTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordWithToken(version: string, xPassword: string, resetPasswordWithTokenRequest: ResetPasswordWithTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Wrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswordWithToken(version, xPassword, resetPasswordWithTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.resetPasswordWithToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendVerificationEmail1(version: string, email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Wrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendVerificationEmail1(version, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.sendVerificationEmail1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAmbassadorCode(version: string, code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Wrapper>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAmbassadorCode(version, code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.validateAmbassadorCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmailAddress1(version: string, email: string, code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleWrapperBoolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmailAddress1(version, email, code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.verifyEmailAddress1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify 2FA challenge code and complete login
         * @param {string} version 
         * @param {TwoFactorVerifyRequest} twoFactorVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyTwoFactor(version: string, twoFactorVerifyRequest: TwoFactorVerifyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyTwoFactor(version, twoFactorVerifyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.verifyTwoFactor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {VerifyTokenRequest} verifyTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyUserEmail(version: string, verifyTokenRequest: VerifyTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleWrapperUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyUserEmail(version, verifyTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.verifyUserEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @param {string} version 
         * @param {DeviceRequest} deviceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceRegistration(version: string, deviceRequest: DeviceRequest, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper> {
            return localVarFp.deviceRegistration(version, deviceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        emailAlreadyExists(version: string, email: string, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperBoolean> {
            return localVarFp.emailAlreadyExists(version, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {EmailExistRequest} emailExistRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        emailExists(version: string, emailExistRequest: EmailExistRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperBoolean> {
            return localVarFp.emailExists(version, emailExistRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Grant PII consent and receive read-only auth tokens
         * @param {string} version 
         * @param {ConsentGrantRequest} consentGrantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantConsentAndLogin(version: string, consentGrantRequest: ConsentGrantRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReadOnlyAuthResponseWrapper> {
            return localVarFp.grantConsentAndLogin(version, consentGrantRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateResetPassword(version: string, email: string, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper> {
            return localVarFp.initiateResetPassword(version, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(version: string, loginRequest: LoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperAuthResponse> {
            return localVarFp.login(version, loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticate user and initiate consent flow for read-only token
         * @param {string} version 
         * @param {string} xAuthorization 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginReadOnlyToken(version: string, xAuthorization: string, loginRequest: LoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReadOnlyAuthResponseWrapper> {
            return localVarFp.loginReadOnlyToken(version, xAuthorization, loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Convert session to read-only token, initiating consent flow if enabled
         * @param {string} version 
         * @param {string} xAuthorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginReadOnlyTokenWithFullAccessToken(version: string, xAuthorization: string, options?: RawAxiosRequestConfig): AxiosPromise<ReadOnlyAuthResponseWrapper> {
            return localVarFp.loginReadOnlyTokenWithFullAccessToken(version, xAuthorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        panelLogin(version: string, loginRequest: LoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperAuthResponse> {
            return localVarFp.panelLogin(version, loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Takes a refresh token in the `x-refresh-token` header. v2.0+ returns a full `AuthResponse`; v1.0 returns only the newly issued access token as a raw string wrapped in the standard envelope (see `RefreshedTokenWrapper`). The refresh token itself is the credential — no bearer `Authorization` header is required.
         * @summary Refresh an access token (supports both regular and read-only tokens)
         * @param {string} version 
         * @param {string} xRefreshToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAccessToken(version: string, xRefreshToken: string, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponseWrapper> {
            return localVarFp.refreshAccessToken(version, xRefreshToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {PlayerSignUpRequest} playerSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(version: string, playerSignUpRequest: PlayerSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperAuthResponse> {
            return localVarFp.register(version, playerSignUpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend 2FA verification code via SMS
         * @param {string} version 
         * @param {TwoFactorResendRequest} twoFactorResendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendTwoFactorCode(version: string, twoFactorResendRequest: TwoFactorResendRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.resendTwoFactorCode(version, twoFactorResendRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {string} code 
         * @param {string} xPassword 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword1(version: string, email: string, code: string, xPassword: string, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper> {
            return localVarFp.resetPassword1(version, email, code, xPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * Redeems the signed, single-use reset token (from the emailed link) and sets a new password supplied in the x-password header.
         * @summary Complete a password reset from an emailed reset link
         * @param {string} version 
         * @param {string} xPassword 
         * @param {ResetPasswordWithTokenRequest} resetPasswordWithTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordWithToken(version: string, xPassword: string, resetPasswordWithTokenRequest: ResetPasswordWithTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper> {
            return localVarFp.resetPasswordWithToken(version, xPassword, resetPasswordWithTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerificationEmail1(version: string, email: string, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper> {
            return localVarFp.sendVerificationEmail1(version, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAmbassadorCode(version: string, code: string, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper> {
            return localVarFp.validateAmbassadorCode(version, code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {string} email 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailAddress1(version: string, email: string, code: string, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperBoolean> {
            return localVarFp.verifyEmailAddress1(version, email, code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify 2FA challenge code and complete login
         * @param {string} version 
         * @param {TwoFactorVerifyRequest} twoFactorVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTwoFactor(version: string, twoFactorVerifyRequest: TwoFactorVerifyRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.verifyTwoFactor(version, twoFactorVerifyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {VerifyTokenRequest} verifyTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUserEmail(version: string, verifyTokenRequest: VerifyTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperUserResponse> {
            return localVarFp.verifyUserEmail(version, verifyTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - interface
 * @export
 * @interface AuthenticationApi
 */
export interface AuthenticationApiInterface {
    /**
     * 
     * @param {string} version 
     * @param {DeviceRequest} deviceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    deviceRegistration(version: string, deviceRequest: DeviceRequest, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper>;

    /**
     * 
     * @param {string} version 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    emailAlreadyExists(version: string, email: string, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperBoolean>;

    /**
     * 
     * @param {string} version 
     * @param {EmailExistRequest} emailExistRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    emailExists(version: string, emailExistRequest: EmailExistRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperBoolean>;

    /**
     * 
     * @summary Grant PII consent and receive read-only auth tokens
     * @param {string} version 
     * @param {ConsentGrantRequest} consentGrantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    grantConsentAndLogin(version: string, consentGrantRequest: ConsentGrantRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReadOnlyAuthResponseWrapper>;

    /**
     * 
     * @param {string} version 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    initiateResetPassword(version: string, email: string, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper>;

    /**
     * 
     * @param {string} version 
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    login(version: string, loginRequest: LoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperAuthResponse>;

    /**
     * 
     * @summary Authenticate user and initiate consent flow for read-only token
     * @param {string} version 
     * @param {string} xAuthorization 
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    loginReadOnlyToken(version: string, xAuthorization: string, loginRequest: LoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReadOnlyAuthResponseWrapper>;

    /**
     * 
     * @summary Convert session to read-only token, initiating consent flow if enabled
     * @param {string} version 
     * @param {string} xAuthorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    loginReadOnlyTokenWithFullAccessToken(version: string, xAuthorization: string, options?: RawAxiosRequestConfig): AxiosPromise<ReadOnlyAuthResponseWrapper>;

    /**
     * 
     * @param {string} version 
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    panelLogin(version: string, loginRequest: LoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperAuthResponse>;

    /**
     * Takes a refresh token in the `x-refresh-token` header. v2.0+ returns a full `AuthResponse`; v1.0 returns only the newly issued access token as a raw string wrapped in the standard envelope (see `RefreshedTokenWrapper`). The refresh token itself is the credential — no bearer `Authorization` header is required.
     * @summary Refresh an access token (supports both regular and read-only tokens)
     * @param {string} version 
     * @param {string} xRefreshToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    refreshAccessToken(version: string, xRefreshToken: string, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponseWrapper>;

    /**
     * 
     * @param {string} version 
     * @param {PlayerSignUpRequest} playerSignUpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    register(version: string, playerSignUpRequest: PlayerSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperAuthResponse>;

    /**
     * 
     * @summary Resend 2FA verification code via SMS
     * @param {string} version 
     * @param {TwoFactorResendRequest} twoFactorResendRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    resendTwoFactorCode(version: string, twoFactorResendRequest: TwoFactorResendRequest, options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * 
     * @param {string} version 
     * @param {string} email 
     * @param {string} code 
     * @param {string} xPassword 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    resetPassword1(version: string, email: string, code: string, xPassword: string, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper>;

    /**
     * Redeems the signed, single-use reset token (from the emailed link) and sets a new password supplied in the x-password header.
     * @summary Complete a password reset from an emailed reset link
     * @param {string} version 
     * @param {string} xPassword 
     * @param {ResetPasswordWithTokenRequest} resetPasswordWithTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    resetPasswordWithToken(version: string, xPassword: string, resetPasswordWithTokenRequest: ResetPasswordWithTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper>;

    /**
     * 
     * @param {string} version 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    sendVerificationEmail1(version: string, email: string, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper>;

    /**
     * 
     * @param {string} version 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    validateAmbassadorCode(version: string, code: string, options?: RawAxiosRequestConfig): AxiosPromise<Wrapper>;

    /**
     * 
     * @param {string} version 
     * @param {string} email 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    verifyEmailAddress1(version: string, email: string, code: string, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperBoolean>;

    /**
     * 
     * @summary Verify 2FA challenge code and complete login
     * @param {string} version 
     * @param {TwoFactorVerifyRequest} twoFactorVerifyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    verifyTwoFactor(version: string, twoFactorVerifyRequest: TwoFactorVerifyRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse>;

    /**
     * 
     * @param {string} version 
     * @param {VerifyTokenRequest} verifyTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    verifyUserEmail(version: string, verifyTokenRequest: VerifyTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<SingleWrapperUserResponse>;

}

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI implements AuthenticationApiInterface {
    /**
     * 
     * @param {string} version 
     * @param {DeviceRequest} deviceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public deviceRegistration(version: string, deviceRequest: DeviceRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).deviceRegistration(version, deviceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public emailAlreadyExists(version: string, email: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).emailAlreadyExists(version, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {EmailExistRequest} emailExistRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public emailExists(version: string, emailExistRequest: EmailExistRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).emailExists(version, emailExistRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Grant PII consent and receive read-only auth tokens
     * @param {string} version 
     * @param {ConsentGrantRequest} consentGrantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public grantConsentAndLogin(version: string, consentGrantRequest: ConsentGrantRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).grantConsentAndLogin(version, consentGrantRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public initiateResetPassword(version: string, email: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).initiateResetPassword(version, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public login(version: string, loginRequest: LoginRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).login(version, loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticate user and initiate consent flow for read-only token
     * @param {string} version 
     * @param {string} xAuthorization 
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public loginReadOnlyToken(version: string, xAuthorization: string, loginRequest: LoginRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).loginReadOnlyToken(version, xAuthorization, loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Convert session to read-only token, initiating consent flow if enabled
     * @param {string} version 
     * @param {string} xAuthorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public loginReadOnlyTokenWithFullAccessToken(version: string, xAuthorization: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).loginReadOnlyTokenWithFullAccessToken(version, xAuthorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public panelLogin(version: string, loginRequest: LoginRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).panelLogin(version, loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Takes a refresh token in the `x-refresh-token` header. v2.0+ returns a full `AuthResponse`; v1.0 returns only the newly issued access token as a raw string wrapped in the standard envelope (see `RefreshedTokenWrapper`). The refresh token itself is the credential — no bearer `Authorization` header is required.
     * @summary Refresh an access token (supports both regular and read-only tokens)
     * @param {string} version 
     * @param {string} xRefreshToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public refreshAccessToken(version: string, xRefreshToken: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).refreshAccessToken(version, xRefreshToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {PlayerSignUpRequest} playerSignUpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public register(version: string, playerSignUpRequest: PlayerSignUpRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).register(version, playerSignUpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend 2FA verification code via SMS
     * @param {string} version 
     * @param {TwoFactorResendRequest} twoFactorResendRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public resendTwoFactorCode(version: string, twoFactorResendRequest: TwoFactorResendRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).resendTwoFactorCode(version, twoFactorResendRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {string} email 
     * @param {string} code 
     * @param {string} xPassword 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public resetPassword1(version: string, email: string, code: string, xPassword: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).resetPassword1(version, email, code, xPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Redeems the signed, single-use reset token (from the emailed link) and sets a new password supplied in the x-password header.
     * @summary Complete a password reset from an emailed reset link
     * @param {string} version 
     * @param {string} xPassword 
     * @param {ResetPasswordWithTokenRequest} resetPasswordWithTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public resetPasswordWithToken(version: string, xPassword: string, resetPasswordWithTokenRequest: ResetPasswordWithTokenRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).resetPasswordWithToken(version, xPassword, resetPasswordWithTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public sendVerificationEmail1(version: string, email: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).sendVerificationEmail1(version, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public validateAmbassadorCode(version: string, code: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).validateAmbassadorCode(version, code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {string} email 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public verifyEmailAddress1(version: string, email: string, code: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).verifyEmailAddress1(version, email, code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify 2FA challenge code and complete login
     * @param {string} version 
     * @param {TwoFactorVerifyRequest} twoFactorVerifyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public verifyTwoFactor(version: string, twoFactorVerifyRequest: TwoFactorVerifyRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).verifyTwoFactor(version, twoFactorVerifyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {VerifyTokenRequest} verifyTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public verifyUserEmail(version: string, verifyTokenRequest: VerifyTokenRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).verifyUserEmail(version, verifyTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

